import { useQuery } from '@tanstack/react-query';
import VendorsTable from './VendorsTable';
import { fetchQuestionnaires } from './VendorsApis';
import { SkeletonFullyVendorPage } from '../LoadingPages/SkeletonVendorPage';

export default function Vendors() {
    const {
        data,
        isLoading,
        error
    } = useQuery({
        queryKey: ['questionnaires'],
        queryFn: fetchQuestionnaires,
        staleTime: 15 * 60 * 1000, // 15 minutes
    });

    if (isLoading) return <SkeletonFullyVendorPage />;

    if (error) {
        return (
            <div className="mt-3">
                <div className="alert alert-danger" role="alert">
                    Error loading data: {error.message}
                </div>
            </div>
        );
    }

    const vendors = data?.questionnaires || [];

    return (
        <div className="mt-3">
            <div className="row mb-5">
                <div className="col-md-4">
                    <h1 className="title">Third-Party Portal</h1>
                </div>
                <p className='p-text'>
                    Welcome <span>{data?.userInfo?.userName}</span> to{' '}
                    <span>{data?.userInfo?.companyName}'s</span> Third-Party Portal.
                    Here, you will be able to complete onboarding questionnaires as well as upload requested documents.
                </p>

                <p className='p-text fw-bold'>Open Assignments</p>
                <VendorsTable
                    vendors={vendors}
                    pirm_addon__Status__c="Pending"
                    isLoading={false}
                />

                <p className='p-text fw-bold pt-4'>Completed Assignments</p>
                <VendorsTable
                    vendors={vendors}
                    pirm_addon__Status__c="Completed"
                    isLoading={false}
                />
            </div>
        </div>
    );
}
